import { LazyLoader } from '@bp/ui-components';
import { BpPage } from 'components/BpPage/BpPage';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import {
  DesktopNavigationTabs,
  DesktopNavigationTabsType,
} from '../../components/NavigationTabs/Desktop/DesktopNavigationTabs';
import { NavigationTabs } from '../../components/NavigationTabs/NavigationTabs';
import { useIsDesktop } from '../../hooks/useIsDesktop';

export const AbsencesPage = () => {
  const { t } = useTranslation();

  const permissions = usePermissionChecker();

  const canViewMyAbsences = permissions?.canViewOwnAbsences();
  const canViewAdministration = permissions?.canViewAbsencesAdministration();
  const canViewEvaluation = permissions?.canViewAbsencesEvaluation();

  const tabs: DesktopNavigationTabsType[] = [
    ...(canViewMyAbsences
      ? [
          {
            title: t('absences.myAbsences'),
            path: 'my-absences',
          },
        ]
      : []),
    ...(canViewAdministration
      ? [
          {
            title: t('absences.administration'),
            path: 'administration',
          },
        ]
      : []),
    ...(canViewEvaluation
      ? [
          {
            title: t('absences.evaluation.title', { count: 1 }),
            path: 'evaluation',
          },
        ]
      : []),
  ];

  const isDesktop = useIsDesktop();

  return (
    <BpPage isForbidden={!permissions?.canViewAbsences()} title={t('absences.title', { count: 2 })}>
      {isDesktop && (
        <>
          <DesktopNavigationTabs tabs={tabs} className='mb-6' />
          <Suspense fallback={<LazyLoader embedded transparent size='l' forceHeight='45vh' />}>
            <Outlet />
          </Suspense>
        </>
      )}
      {!isDesktop && (
        <>
          <NavigationTabs tabs={tabs} size={'m'} />
        </>
      )}
    </BpPage>
  );
};
